import {
  CalculatorOperations,
  getIngredientsBySpongeCakeType,
  squareSpongeCakeField
} from '../../../../helpers/cake'
import { squareSpongeCakeValidator } from './SquareSpongeCakeValidator'

interface SquareSpongeCakeCalculatorActions {
  sideLength: string
  errors: string[]
  chosenSpongeType: string
  ingredients: string[]
  result: number | null
  calculate: () => void
}

export const initialSquareSpongeCakeReducer: SquareSpongeCakeCalculatorActions =
  {
    sideLength: '',
    errors: [],
    chosenSpongeType: '',
    ingredients: [],
    result: null,
    calculate: (): void => {
      // Initial method
    }
  }

const updateValidationErrors = (
  errors: string[],
  state: SquareSpongeCakeCalculatorActions
): SquareSpongeCakeCalculatorActions => ({
  ...state,
  errors,
  ingredients: [],
  result: null
})

const calculateResult = (
  state: SquareSpongeCakeCalculatorActions
): SquareSpongeCakeCalculatorActions => {
  const result = Math.round(squareSpongeCakeField(parseFloat(state.sideLength)))
  return {
    ...state,
    result,
    ingredients: getIngredientsBySpongeCakeType(state.chosenSpongeType, result),
    errors: []
  }
}

export enum SquareSpongeCakeReducerActionName {
  CALCULATE_RESULT = 'CALCULATE_RESULT',
  UPDATE_SQUARE_SPONGE_CAKE_CALC_DATA = 'UPDATE_SQUARE_SPONGE_CAKE_CALC_DATA'
}

export type SquareSpongeCakeReducerActions =
  | {
      type: SquareSpongeCakeReducerActionName.CALCULATE_RESULT
    }
  | {
      type: SquareSpongeCakeReducerActionName.UPDATE_SQUARE_SPONGE_CAKE_CALC_DATA
      data: CalculatorOperations
    }

const calculate = (
  state: SquareSpongeCakeCalculatorActions
): SquareSpongeCakeCalculatorActions => {
  const validationErrors = squareSpongeCakeValidator(state.sideLength)
  if (validationErrors.length > 0) {
    return updateValidationErrors(validationErrors, state)
  }
  return calculateResult(state)
}

const updateCalcData = (
  data: CalculatorOperations,
  state: SquareSpongeCakeCalculatorActions
): SquareSpongeCakeCalculatorActions => ({
  ...state,
  [data.fieldName]: data.fieldValue
})

export const squareSpongeCakeReducer = (
  state: SquareSpongeCakeCalculatorActions,
  action: SquareSpongeCakeReducerActions
): SquareSpongeCakeCalculatorActions => {
  switch (action.type) {
    case SquareSpongeCakeReducerActionName.CALCULATE_RESULT:
      return calculate(state)
    case SquareSpongeCakeReducerActionName.UPDATE_SQUARE_SPONGE_CAKE_CALC_DATA:
      return updateCalcData(action.data, state)
    default:
      return state
  }
}
